export const reservation: any = {
  status: {
    arranged: "予約済み",
    cancelled: "キャンセル済み",
    unconfirmed: "予約処理中・未確認",
    created: "予約処理中",
  },
};
